import type { MatchEntityState } from 'Store/entities/types';

const initialState: MatchEntityState = {};
export default initialState;
